export const baseURL = process.env.VUE_APP_API_PROTOCOL + 'subdomain.' + process.env.VUE_APP_API_BASE_DOMAIN + process.env.VUE_APP_API_VERSION

export function replaceSubdomain (subdomain: string) {
  return baseURL.replace(/(:\/\/)subdomain(\.)/, `://${subdomain}.`)
}
